import { Action } from '@ngrx/store';
import {
  LaborSchedulerGanttAllItemsResponseInterface,
  ILaborSchedulerItemResponse,
  SaveLaborSchedulerItemInterface,
  IItemsToPlannedResponse,
  ILoadTeamsUsersParams,
} from '../../shared/service/labor-scheduler/labor-scheduler.interface';
import { TaskType } from '../../view/scheduler/scheduler.model';
import { AllSettledResolvedInterface } from '../../shared/model/interface/generic-api-response.model';
import { CheckInTableQueryParams } from '../../view/reports/check-in-logs/check-in-logs.model';
import { ILaborSchedulerDownloadExcelPayload } from '../../view/labor-scheduler/labor-scheduler-list-view/labor-scheduler-list-view.model';

export enum LaborSchedulerActionTypes {
  LoadLaborSchedulerItems = '[LaborScheduler] Load Labor Scheduler Items',
  LaborSchedulerItemsLoaded = '[LaborScheduler] Labor Scheduler Items Loaded',
  LoadLaborSchedulerGanttAllItems = '[LaborScheduler] Load Labor Scheduler Gantt All Items',
  LaborSchedulerGanttAllItemsLoaded = '[LaborScheduler] Labor Scheduler Gantt All Items Loaded',
  SaveAndDeployLaborSchedulerItems = '[LaborScheduler] Save And Deploy Labor Scheduler Items',
  SaveAndDeployLaborSchedulerItemsCompleted = '[LaborScheduler] Save And Deploy Labor Scheduler Items Completed',
  LoadItemsToPlannedAllItems = '[LaborScheduler] Load Items To Planned All Items',
  ItemsToPlannedAllItemsLoaded = '[LaborScheduler] Items To Planned All Items Loaded',
  DownloadLaborSchedulerExcel = '[LaborScheduler] Download Labor Scheduler Excel',
  DownloadLaborSchedulerExcelCompleted = '[LaborScheduler] Download Labor Scheduler Excel Completed',
  FetchError = '[LaborScheduler] FetchError',
}

export class LoadLaborSchedulerItems implements Action {
  readonly type = LaborSchedulerActionTypes.LoadLaborSchedulerItems;

  constructor(public scenarioId: number) {}
}

export class LaborSchedulerItemsLoaded implements Action {
  readonly type = LaborSchedulerActionTypes.LaborSchedulerItemsLoaded;

  constructor(public payload: ILaborSchedulerItemResponse[]) {}
}

export class LoadLaborSchedulerGanttAllItems implements Action {
  readonly type = LaborSchedulerActionTypes.LoadLaborSchedulerGanttAllItems;

  constructor(public scenarioId: number, public checkInQuery: CheckInTableQueryParams) {}
}

export class LaborSchedulerGanttAllItemsLoaded implements Action {
  readonly type = LaborSchedulerActionTypes.LaborSchedulerGanttAllItemsLoaded;

  constructor(public payload: LaborSchedulerGanttAllItemsResponseInterface) {}
}

export class SaveAndDeployLaborSchedulerItems implements Action {
  readonly type = LaborSchedulerActionTypes.SaveAndDeployLaborSchedulerItems;

  constructor(
    public scenarioId: number,
    public taskType: TaskType,
    public saveLaborSchedulerItems: SaveLaborSchedulerItemInterface[],
    public lineIds: number[],
    public isDeploy: boolean = false,
  ) {}
}

export class SaveAndDeployLaborSchedulerItemsCompleted implements Action {
  readonly type = LaborSchedulerActionTypes.SaveAndDeployLaborSchedulerItemsCompleted;

  constructor(public payload: AllSettledResolvedInterface[]) {}
}

export class LoadItemsToPlannedAllItems implements Action {
  readonly type = LaborSchedulerActionTypes.LoadItemsToPlannedAllItems;

  constructor(public payload: ILoadTeamsUsersParams) {}
}

export class ItemsToPlannedAllItemsLoaded implements Action {
  readonly type = LaborSchedulerActionTypes.ItemsToPlannedAllItemsLoaded;

  constructor(public payload: IItemsToPlannedResponse) {}
}

export class DownloadLaborSchedulerExcel implements Action {
  readonly type = LaborSchedulerActionTypes.DownloadLaborSchedulerExcel;

  constructor(public payload: ILaborSchedulerDownloadExcelPayload) {}
}

export class DownloadLaborSchedulerExcelCompleted implements Action {
  readonly type = LaborSchedulerActionTypes.DownloadLaborSchedulerExcelCompleted;
}

export class FetchError implements Action {
  readonly type = LaborSchedulerActionTypes.FetchError;

  constructor(public payload: any) {}
}

export type LaborSchedulerActions =
  | LoadLaborSchedulerItems
  | LaborSchedulerItemsLoaded
  | LoadLaborSchedulerGanttAllItems
  | LaborSchedulerGanttAllItemsLoaded
  | SaveAndDeployLaborSchedulerItems
  | SaveAndDeployLaborSchedulerItemsCompleted
  | LoadItemsToPlannedAllItems
  | ItemsToPlannedAllItemsLoaded
  | DownloadLaborSchedulerExcel
  | DownloadLaborSchedulerExcelCompleted
  | FetchError;
